import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import "./ProducerDeclaration.scss"
import messages from "../../assets/i18n";
import { HeaderActions, FooterActions, ToastMessage, ButtonStandard } from "../../components";
import { DateLabel } from "../../components/Labels";
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { Container, Row, Col } from "react-bootstrap";


function ProducerDeclaration(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);

    const orderList         = useSelector(state => state.orderList);
    const isLoadingUpload   = useSelector(state => state.producerDeclaration.isLoadingProducerDeclaration);
    const isLoadingLastFile = useSelector(state => state.producerDeclaration.isLoadingLastDeclaration);
    const lastFile          = useSelector(state => state.producerDeclaration.lastFile);
    const lastFileStatus    = useSelector(state => state.producerDeclaration.lastFileStatus);

    const ACCEPT_TYPE = '.doc,.docx,application/pdf';

    const [showToast,    setShowToast]    = useState(false);
    const [uploadedFile, setUploadedFile] = useState(undefined);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-error');

    // utilizado para saber de qual tela o usuário veio
    const [fromPage, setFromPage] = useState('/main');

    useEffect(() => {
        if (props.history.location.from === '/conciliation-status') {
            setFromPage('/conciliation-status');
        }
		dispatch({
			type: 'GET_LAST_PRODUCER_DECLARATION',
            payload: {orderId: orderList[0] ? orderList[0].id : ''}
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    const validateAndStoreLocalFile = file => {
        setUploadedFile(undefined);

        if (!file || file.length === 0) {
            setShowToast(true);
            setMessageType('toast-error')
            setMessageError(messages[lang].mustBePDF);
        } else if (file.length > 1) {
            setShowToast(true);
            setMessageError('error');
        } else if (file[0].type !== 'application/pdf' && file[0].type !== 'application/msword' && file[0].type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            setShowToast(true);
            setMessageError(messages[lang].mustBePDF);
        } else {
            setUploadedFile(file[0]);
        }
    
    };

    const pageBack = () => {
		history.push(fromPage);
	};

    const removeFile = () => {
        setUploadedFile(undefined);
        dispatch({
            type: "SET_LAST_PRODUCER_DECLARATION",
            payload: undefined
        });
    };

    const downloadFile = () => {
		let reader = new FileReader();
        let file = convertBase64ToFile(lastFile)
		reader.readAsBinaryString(file);
		reader.onload = () => {
			let base64 = new FileReader();
			base64.readAsDataURL(file);
			base64.onload = () => {
				const downloadLink = document.createElement("a");
				downloadLink.href = base64.result;
				downloadLink.download = file.name;
				downloadLink.click();
			}
		};		
	};

	const convertBase64ToFile = (base64) => {
        if (base64) {        
            const byteString = window.atob(base64);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i);
            }

            let extension = 'pdf'

            if (base64[0] === '0' || base64[0] === 'O') {
                extension = 'doc'
            } else if (base64[0] === 'U') {
                extension = 'docx'
            }
            const filename = messages ? (messages[lang].fileProducerDeclaration + '.' + extension): "file.pdf"
            return new File([ab], filename);
        }
    };

    const handleButtonNext = () => {
        if (uploadedFile) {
            dispatch({
                type: 'SET_PRODUCER_DECLARATION',
                payload: {orderId: orderList[0] ? orderList[0].id : '', file: uploadedFile}
            })          
        }

        if (fromPage === '/main') {
            history.push(`/reconcile`);
        }        
    }

    const disableNextButton = () => {
        if (fromPage === '/main') {        
            return (!uploadedFile && !lastFile) || isLoadingUpload
        } else {
            if (!uploadedFile) {
                return true
            }
        }
    };

    const buttonNext = () => (
        <ButtonStandard
          id="producer-declaration-next_button"
          text={fromPage === '/main' ? messages[lang].next : messages[lang].save}
          isloading={false}
          disabled={disableNextButton()}
          className="btn btn-primary px-3 py-2 btn-light"
          onClick={handleButtonNext}
        />
    )

    const titlePage = () => {
        let order = orderList[0] ? orderList[0] : 
        {
            id: '2058720',
            calendarioComercial: false,
            dtEmissao: '2022-05-05',
            qtCompra: '22'
        };
		return (
			<>
				{messages[lang].producerDeclaration}
				<span className="ml-2 font-weight-normal word-spacing-25">
				{order.id} - {order.calendarioComercial ? order.calendarioComercial.semanaComercial : ''}
				  {" | "} 
					<DateLabel date={new Date(order.dtEmissao)}	/>
					{" "} 
					<span className="word-spacing-0">
						{order.qtCompra} {messages[lang].parts}
					</span>
				</span>
			</>
		)
	}
    

	return (
		<div className="producer-declaration-page">
           <ToastMessage show={showToast} setShow={setShowToast} message={messageError} toastClass={messageType} />
            <HeaderActions pageBack={pageBack} titlePage={titlePage()} />

            {
                isLoadingLastFile ? 
                <div className="loader">
                    <LoadingSpinner />    
                </div>                 
                :

                <UploadFiles
                    accept={ACCEPT_TYPE}
                    validateAndStoreLocalFile={validateAndStoreLocalFile}
                    uploadedFile={lastFile && lastFileStatus ? convertBase64ToFile(lastFile) : uploadedFile}
                    downloadFile={lastFile && lastFileStatus ? downloadFile : null}
                    removeFile={removeFile}
                />
            } 
           
            {
                lastFileStatus ?
                <Container className="mt-2 pt-3 mb-5 pb-5">
                    <Container className="mt-2 pt-3">
                        <Row>
                            <Col className="px-4">
                                <Col className="rounded-top bg-color-primary py-2">
                                    <span className="text-2">{messages[lang].statusUltimaDeclaracao}</span>
                                </Col>
                                <Col className="rounded-bottom bg-color-secondary py-2 mt-2">
                                    <span className="text-2">{lastFileStatus}</span>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                :
                null
            }

            <FooterActions ButtonGroupRight={buttonNext} />
		</div>
	)
}

export default withRouter(ProducerDeclaration);